export const fieldIds = {
  loanPurpose: '19',
  hasCoborrower: 'CX.HASCOBORROWER',
  sameMailingAddressAsBorrower: 'CX.CMAILINGSAMEASB',
  sameAddressAsBorrower: 'CX.CADDRESSSAMEASB',
  borrowerMailingAddressSameAsPresent: '1819',
  refinancingCurrentProperty: 'CX.REFICURPROP',
  isPreApproval: 'CX.PREAPPROVAL',
  hasRealtor: 'CX.HASREALTOR',
  needsRealtor: 'CX.NEEDSREALTOR',
  authorizationInsuranceQuote: 'CX.INSQUOTE',
  isAdjustableRateMortgage: '608',
};
